
import { Component, Prop, Vue } from "vue-property-decorator";
import BuroPicker from "@/components/pickers/BuroPicker.vue";

/**
 * Personelin bürosunu değiştirme diyaloğu.
 *
 * Yalnızca büro bağını değiştirir; kişinin durumu, rolü, kullanıcı hakkı
 * (koltuk) sayısı, bekleyen daveti ve oturumu etkilenmez.
 *
 * Hatalar diyaloğun İÇİNDE gösterilir; kapanıp kaybolmaz.
 */
@Component({ components: { BuroPicker } })
export default class BuroDegistirDialog extends Vue {
  @Prop({ required: true }) item!: any;
  /** Bulunulan (kaynak) büro. */
  @Prop({}) buroId!: number | string | null;
  @Prop({ default: false }) disabled!: boolean;
  @Prop({ default: "" }) tooltip!: string;

  show: boolean = false;
  kaydediliyor: boolean = false;
  hedefBuroId: number | null = null;
  kaynakBuroId: number | null = null;
  mod: string = "tasi";
  hata: string = "";

  get personelAdi(): string {
    const ad = `${this.item?.first_name ?? ""} ${this.item?.last_name ?? ""}`.trim();
    return ad !== "" ? ad : this.item?.email ?? "";
  }

  /** Kişinin bağlı olduğu bürolar (backend `buro` ucundan gelir). */
  mevcutBurolar: Array<any> = [];

  get cokBurolu(): boolean {
    return this.mevcutBurolar.length > 1;
  }

  get haricBurolar(): Array<number> {
    // Kişinin hâlihazırda bulunduğu bürolar hedef olamaz.
    return this.mevcutBurolar.map((b: any) => Number(b.id));
  }

  get hataAlan(): Array<string> {
    return [];
  }

  ac() {
    this.show = true;
    this.hata = "";
    this.hedefBuroId = null;
    this.mod = "tasi";
    this.kaynakBuroId = this.buroId ? Number(this.buroId) : null;
    this.burolariYukle();
  }

  kapat() {
    if (this.kaydediliyor) return;
    this.show = false;
  }

  burolariYukle() {
    // `/buro` yalnızca TEK büro döndürür (eski uç, başka ekranlar ona bağlı);
    // kişinin gerçekten kaç büroda olduğunu `/burolar` verir. Yanlış uç
    // kullanıldığında çok bürolu personelde kaynak büro hiç sorulmuyordu.
    this.$http
      .get("/api/v1/personel/" + this.item.id + "/burolar")
      .then((res: any) => {
        const veri = res.data?.data ?? res.data ?? [];
        this.mevcutBurolar = Array.isArray(veri) ? veri : [veri].filter(Boolean);
        if (!this.kaynakBuroId && this.mevcutBurolar.length === 1) {
          this.kaynakBuroId = Number(this.mevcutBurolar[0].id);
        }
      })
      .catch(() => {
        // Uç okunamazsa bulunulan büroyu kaynak kabul et; sunucu yine doğrular.
        this.mevcutBurolar = this.buroId ? [{ id: Number(this.buroId), isim: "Mevcut büro" }] : [];
      });
  }

  kaydet() {
    if (!this.hedefBuroId || this.kaydediliyor) return;
    this.kaydediliyor = true;
    this.hata = "";

    this.$http
      .post("/api/v1/personel/" + this.item.id + "/buro-degistir", {
        hedef_buro_id: this.hedefBuroId,
        kaynak_buro_id: this.mod === "tasi" ? this.kaynakBuroId : null,
        mod: this.mod,
      })
      .then((res: any) => {
        const veri = res.data?.data ?? res.data ?? {};

        // Sunucu iş kuralı reddi (200 ile `kod` döner): diyalogda göster.
        if (veri.kod) {
          this.hata = veri.message || "İşlem tamamlanamadı.";
          return;
        }

        (this as any).$toast?.success("Personelin bürosu güncellendi.");
        this.show = false;
        this.$emit("success");
        this.$emit("load");
      })
      .catch((e: any) => {
        this.hata =
          e?.response?.data?.data?.message ||
          e?.response?.data?.message ||
          "İşlem tamamlanamadı. Lütfen tekrar deneyin.";
      })
      .finally(() => {
        this.kaydediliyor = false;
      });
  }
}
